_collow.components.QuizFillout = class QuizFillout extends (
  _collow.components.Base
) {
  root;
  elements;
  params;
  answer = [];
  studentAnswer = [];
  inputFields;

  constructor(root, elements, params) {
    super();

    this.root = root;
    this.elements = elements;
    this.params = params;

    this.getAnswers();
    this.getInputFields();
    this.listen(document.body, "_collow.quiz-finished", this.showResults);
  }

  getInputFields = () => {
    this.root
      .querySelectorAll("[data-quiz-fillout]")
      .forEach((input, index) => {
        input.dataset.quizFillout = index;
        const answerLength = this.answer[index].length;
        input.dataset.quizFilloutLength = answerLength;
        this.listen(input, "input", this.sendAnswers);
      });
    this.inputFields = this.root.querySelectorAll("[data-quiz-fillout]");
  };

  sendAnswers = (event) => {
    const value = event.target.value.toLowerCase().trim();
    const answerIndex = event.target.dataset.quizFillout;
    this.studentAnswer[answerIndex] = value;
    let points = 0;

    if (this.studentAnswer.length == this.answer.length) {
      this.answerTrue = true;
      this.studentAnswer.forEach((res) => {
        const answerCorrect = this.answer.includes(res);
        if (!answerCorrect) this.answerTrue = false;
      });
      if (this.answerTrue) points = this.params.points;
    }

    this.dispatch(this.root, "_collow.quiz-points", {
      points,
      index: this.params.index,
    });
  };

  getAnswers = () => {
    const htmlAnswer = this.params.answer.trim().toLowerCase().split(",");
    this.answer = htmlAnswer;

    this.root.removeAttribute("data-quiz-fillout:answer");
  };

  showResults = () => {
    this.inputFields.forEach((input) => (input.disabled = true));
    this.dispatch(
      this.root,
      `_collow.hint-${this.params.index}`,
      this.answerTrue
    );

    this.dispatch(
      this.root,
      "_collow.quiz-finished",
      { correct: this.answerTrue },
      false
    );

    const answers = this.answer.map(
      (ans, index) => ans == this.studentAnswer[index]
    );
    Array.from(this.inputFields).forEach((el, ind) => {
      el.dataset[`fillout${answers[ind] ? "Correct" : "False"}`] = "";
    });

    if (answers.includes(false)) {
      const template = this.elements.answerTemplate.innerHTML;
      this.elements.answerBox.removeAttribute("hidden");
      const answersHtml = answers
        .map((ans, ind) => {
          if (!ans)
            return template
              .replace("ANSWER-FALSE", this.studentAnswer[ind])
              .replace("ANSWER-CORRECT", this.answer[ind]);
        })
        .filter((el) => el)
        .join("");
      this.elements.answerBox.insertAdjacentHTML("beforeend", answersHtml);
    }
  };
};
